<template>
    <div class="other-profile-wrapper">
        <v-row justify="center">
            <v-col
                class="mt-2 pa-0 ma-0"
                @click="handleBackNav"
                cols="1"
            >
                <v-icon size="33">mdi-chevron-left</v-icon>
            </v-col>
            <v-spacer />
            <v-col class="text-center mt-4 pa-0 ma-0" cols="1">
                <v-menu left close-on-content-click offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <icon-menu v-bind="attrs" v-on="on" />
                    </template>
                    <v-list class="UserControls-list">
                        <v-list-item class="UserControls-item">
                            <v-list-item-title @click="handleProfileLink"
                                >{{ $t("dialogs.profile_link") }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item class="UserControls-item">
                            <v-list-item-title @click="handleShowGiftSubscription"
                                >{{ $t("dialogs.gifted_subscription") }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item class="UserControls-item">
                            <v-list-item-title
                                @click="openReportMessageDialog"
                                >{{ $t("dialogs.report") }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item class="UserControls-item">
                            <v-list-item-title @click="openBlockDialog">
                                {{
                                    user.blocked
                                        ? $t("dialogs.unblock")
                                        : $t("dialogs.block")
                                }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
        <v-row v-if="!isOwnPage" justify="center">
            <div
                class="ProfileImage-wrapper"
                :class="{
                    'without-circle': !user.isExistStory,
                }"
            >
                <profile-image
                    v-if="user.id"
                    :has-not-watched-stories="user.hasNotWatchedStories"
                    :is-exist-story="user.isExistStory"
                    size="136"
                    :img="profileImage"
                    :username="user.name"
                    :id="user.id"
                    class="mt-6"
                    :display-user-story="displayUserStory"
                />
                <follow-button
                    v-if="user.id"
                    :is-following="user.isFollowing"
                    :user-id="user.id"
                    @click="clickFollow"
                />
            </div>
        </v-row>
        <v-row v-else justify="center">
            <div class="ProfileImage-wrapper">
                <profile-image
                    v-if="user.id"
                    :has-not-watched-stories="user.hasNotWatchedStories"
                    :is-exist-story="user.isExistStory"
                    size="136"
                    :img="profileImage"
                    :username="user.name"
                    :id="user.id"
                    class="mt-6"
                />
            </div>
        </v-row>
        <v-row justify="center">
            <div class="name mt-3 d-flex justify-center align-center">
                <span>
                    {{ user.name }}
                </span>
                <verified-icon
                    v-if="user.verified"
                    :height="20" :width="20" class="ml-1" />
                <span @click="handleShowInformDialog($t('dialogs.holiday_mood.other_user_info', { user_name: user.name }))">
                    <holiday-mood-icon v-if="user.on_holiday_mood"/>
                </span>
            </div>
        </v-row>
        <v-row justify="center" class="mb-1">
            <div v-if="isUserOnline" class="online-badge">
                <span class="online-dot"></span>
                <span class="online-text">ONLINE</span>
            </div>
        </v-row>
        <v-row align="center" justify="center">
            <span class="bio mr-10 ml-10">{{ user.bio }}</span>
        </v-row>
        <v-row align="center" justify="center" class="mt-1" v-if="user.country_id">
            <img :src="require(`@/assets/images/flags/${user.country_code.toLowerCase()}.png`)" :alt="user.country_name" class="flags mr-2" />
            <span class="country">{{ user.country_name }}</span>
        </v-row>
        <template v-if="user.amazon || user.instagram || user.twitter">
            <v-row
                v-if="!isOwnPage"
                class="icons-wrapper"
                align="center"
                justify="center"
            >
                <v-col>
                    <div class="d-flex align-center justify-center">
                            <a v-if="user.amazon" :href="user.amazon" class="d-flex">
                                <img
                                    :src="require('@/assets/images/logo/amazon.png')"
                                    alt="x"
                                    title="x"
                                    width="24px"
                                />
                            </a>
                            <a v-if="user.instagram" :href="user.instagram" class="d-flex">
                                <img
                                    :src="require('@/assets/images/logo/instagram.png')"
                                    alt="x"
                                    title="x"
                                    width="24px"
                                />
                            </a>
                            <a v-if="user.twitter" :href="user.twitter" class="d-flex">
                                <img
                                    :src="require('@/assets/images/logo/x.png')"
                                    alt="x"
                                    title="x"
                                    width="24px"
                                />
                            </a>
                    </div>
                </v-col>
            </v-row>
        </template>

        <div
            v-if="!isOwnPage && isActionsReady"
            class="other-user__actions mb-3"
        >
            <div class="other-user__actions-item">
                <div class="other-user__actions-icon-box">
                    <div class="other-user__actions-icon">
                        <send-message :companion="user" />
                        <span>{{ $t('pages.other_user.labels.icons.message') }}</span>
                    </div>
                </div>
            </div>
            <div class="other-user__actions-item" v-if="this.showSubscribe">
                <div class="other-user__actions-icon-box">
                    <div class="other-user__actions-icon">
                        <div class="top-icon">
                            <router-link v-if="user.hasTips" :to="getSecondMenu">
                                <menu-icon 
                                    :width="24"
                                    :height="32"/>
                            </router-link>
                            <div v-else @click="handleShowInformDialog($t('dialogs.has_no_tips'))">
                                <menu-icon 
                                    width="30"
                                    height="30"/>
                            </div>
                        </div>
                        <span>{{ $t('pages.other_user.labels.icons.menu') }}</span>
                    </div>
                </div>
            </div>
            <div class="other-user__actions-item" v-if="this.showSubscribe">
                <div class="other-user__actions-icon-box">
                    <div class="other-user__actions-icon">
                        <div class="top-icon">
                            <router-link to="">
                            <dollor-icon 
                                width="30"
                                height="30" 
                                @click="handleShowTips"/>
                            </router-link>
                        </div>
                        <span>{{ $t('pages.other_user.labels.icons.tip') }}</span>
                    </div>
                </div>
            </div>
            <div class="other-user__actions-item" v-if="user.verified">
                <div class="other-user__actions-icon-box">
                    <div class="other-user__actions-icon">
                        <div @click="handleStreamsButtonClick()"
                        :class="{'is-user-live': isUserLive}">
                            <live-stream-icon :height="32" :width="32" :icon-color="isUserLive ? '#ff0000' : '#ffffff'"/>
                        </div>
                        <span>{{ $t('pages.other_user.labels.icons.live') }}</span>
                    </div>
                </div>
            </div>
            <!-- && isBoxActive -->
            <div class="other-user__actions-item" v-if="user.verified && isBoxActive">
                <div class="other-user__actions-icon-box">
                    <div class="other-user__actions-icon">
                        <div @click="handleMysteryBoxDialog()">
                            <mystery-box-badge-icon class="mt-1"/>
                        </div>
                        <div class="mystery-label">
                            <span class="mystery">{{ $t('pages.other_user.labels.icons.mystery') }}</span>    
                            <span class="box">{{ $t('pages.other_user.labels.icons.box') }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="other-user__actions-item" v-if="user.dream_goal && user.dream_goal.data && user.dream_goal.data.is_activated === 1">
                <div class="other-user__actions-icon-box">
                    <div class="other-user__actions-icon">
                        <div class="top-icon">
                            <router-link to="">
                                <v-progress-circular
                                    :value="progressDreamGoal"
                                    :rotate="-90"
                                    :size="34"
                                    :width="3"
                                    color="#ff8818"
                                    :style="{ '--v-progress-circular-background': '#111111' }"
                                >
                                <dream-goal-icon
                                    class="icon-goal"
                                    :width="20"
                                    :height="20" 
                                    @click="handleShowDreamGoalTips"/>
                                </v-progress-circular>
                            </router-link>
                        </div>
                        <span>{{ $t('pages.other_user.labels.icons.dream') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <v-row
            v-if="showSubscribe"
            class="mr-3 ml-3 mt-6"
            align="center"
            justify="center"
        >
            <gradient-button
                v-if="isResubscribeAvailable"
                :loading="$store.getters.loadingBtn('subscribeBtn')"
                @click="resubscribeMethod"
                block
            >
                {{ $t("dialogs.subscribe_for_free") }}
            </gradient-button>

            <gradient-button
                v-else-if="
                    (!user.isSubscribed || isResubscribeAvailable) &&
                    Number(user.subscribePrice) > 0 &&  
                    !isCreatorSubscribe
                "
                :loading="$store.getters.loadingBtn('subscribeBtn')"
                @click="subscribeMethod"
                block
            >
                {{ $t("dialogs.subscribe_for") }} {{ user.subscribePrice
                }}{{ currency }} (Per Month)
            </gradient-button>

            <gradient-button
                v-else-if="
                    (!user.isSubscribed || isResubscribeAvailable) &&
                    Number(user.subscribePrice) === 0 &&
                    !isCreatorSubscribe
                "
                :loading="$store.getters.loadingBtn('subscribeBtn')"
                @click="subscribeMethod"
                block
            >
                {{ $t("dialogs.subscribe_for_free") }}
            </gradient-button>

            <gradient-button
                v-else
                :loading="$store.getters.loadingBtn('unsubscribeBtn')"
                @click="unsubscribeMethod"
                block
            >
                <app-icon icon="check" size="18" class="mr-3 done" />
                {{ $t("dialogs.subscribed") }}!
            </gradient-button>

            <div
                v-if="isResubscribeAvailable"
                class="text-center grey--text text-body-2"
            >
                {{ $t("dialogs.active_until") }}
                {{
                    formatDate(
                        convertUTCDatetimeToLocal(
                            user.subscriptionInfo.expired_at
                                .replace("T", " ")
                                .replace(".000000Z", "")
                        )
                    )
                }}
            </div>
        </v-row>
        <!-- Achievements -->
        <v-row class="mr-3 ml-0 mt-6" align="center" justify="center" v-if="user.show_achievements_section && achievements.length > 0">
            <v-col cols="12">
                <!-- <h3 class="white--text mb-3 section-title">
                    <hall-fames />
                    {{ $t('pages.other_user.achievements.title') }}
                </h3> -->
                 <v-row class="align-center">
                    <v-col cols="2">
                        <hall-fames class="section-title" />
                    </v-col>
                    <v-col cols="8" class="pl-4">
                        {{ $t('pages.other_user.achievements.title') }}
                    </v-col>
                </v-row>
                <v-slide-group class="achievements-scroll pl-10">
                    <v-slide-item v-for="(achievement, index) in achievements" :key="index">
                        <v-card
                            class="pa-4 d-flex flex-column align-center justify-center text-center achievement-card ma-2"
                            outlined
                        >
                        <div class="achievements-title font-weight-bold mt-2">
                            {{ achievement.category }}
                        </div>

                        <rank-first v-if="achievement.rank == 1"/>
                        <rank-second v-if="achievement.rank == 2"/>
                        <rank-third v-if="achievement.rank == 3"/> 

                        <div class="achievements-date grey--text text--lighten-1">
                            {{ achievement.month }} {{ achievement.year }}
                        </div>
                        </v-card>
                    </v-slide-item>
                </v-slide-group>
            </v-col>
        </v-row>

        <!-- Top Tippers -->
        <div class="mr-3 ml-3 mt-6" v-if="user.show_top_tippers_section && tippers.length > 0">
            <div class="top-tippers">
                <!-- <h3 class="white--text mb-4 section-title">
                    <tipper-icon />
                    {{ $t('pages.other_user.top_tippers.title') }}
                </h3> -->
                <v-row class="">
                    <v-col cols="2">
                        <tipper-icon class="section-title mr-3" />
                    </v-col>
                    <v-col cols="8" class="">
                        <span>{{ $t('pages.other_user.top_tippers.title') }}</span>
                    </v-col>
                </v-row>
                <div class="d-flex justify-center align-end tipper-items">
                <div
                    v-for="(tipper, index) in tippers"
                    :key="index"
                    class="tipper-item"
                    :class="{
                    'first-place': index === 0,
                    'second-place': index === 1,
                    'third-place': index === 2
                    }"
                >
                    <v-card
                    class="pa-4 d-flex flex-column align-center justify-center tipper-card"
                    outlined
                    >
                        <div class="ranking-number">{{ index + 1 }}</div>
                        <img :src="tipper.avatar_url" alt="tipper" class="avatar" />
                        <div class="mt-2 tipper-username white--text">{{ tipper.name }}</div>
                    </v-card>
                </div>
                </div>
            </div>
        </div>

        <tip-menu-dialog
            @close="isShowTips = false"
            v-if="isShowTips"
            :target-verified="user.verified"
            :target-username="user.name"
            :has-radio="false"
            @save="sendTip"
        />
        <bottom-bar :active="true" :model="false"> </bottom-bar>
        <subscribe-dialog
            v-if="subscribeInfo"
            :price="user.subscribePrice"
            :subscription="user.subscription"
            :subscription-bundles="user.subscription.bundles || defaultBundles"
            @subscribe="handleSubscribe"
            @close="closeSubscribeInfo"
        />
        <resubscribe-dialog
            v-if="resubscribeInfo"
            @subscribe="handleResubscribe"
            @close="closeSubscribeInfo"
        />
        <unsubscribe-dialog
            v-if="unsubscribeWarning"
            @unsubscribe="handleUnsubscribe"
            @close="closeUnsubscribeWarning"
        />
        <insufficient-funds-dialog
            v-if="insufficientFundsError"
            @close="handleCloseInsufficientFundsError"
        />
        <direct-message-dialog
            v-if="showDirectMessageDialog"
            :subscribe_price="subscribePrice"
            :direct_price="directPrice"
            @subscribe="handleSubscribe"
            @direct-message="handleDirectMessage"
            @close="handleCloseDirectMessageDialog"
        />
        <report-message-dialog
            v-if="showReportMessageDialog"
            @report="handleSendReportMessage"
            @close="closeReportMessageDialog"
        />
        <inform-dialog
            :text="InformDialogText"
            v-if="showInformDialog"
            @close="showInformDialog = false"
        />
        <no-streams-scheduled-dialog
            v-if="showNoStreamsScheduledDialog"
            :username="user.name"
            @close="showNoStreamsScheduledDialog = false"
        />
        <insufficient-funds-dialog
            v-if="showInsufficientFundsDialog"
            @close="showInsufficientFundsDialog = false"
        />
        <dream-goal-dialog
            v-if="isShowDreamGoalTips"
            :dream-goal="user.dream_goal.data"
            :contributors="user.dream_goal.contributorCount"
            @save="sendCreatorDreamGoalTip"
            @close="isShowDreamGoalTips = false"
        />
        <gift-subscription-dialog
            @close="isShowGiftSubscription = false"
            v-if="isShowGiftSubscription"
            :target-verified="user.verified"
            :target-username="user.name"
            :has-radio="false"
            :is-subscribe="user.subscribeUser"
            @save="sendCreatorGiftSubscription"
        />
        <mystery-box-reward-dialog 
            v-if="showRequestPrice"
            :data="rewardData"
            :result="mysteryBoxResult"
            :won="mysteryBoxWon"
            :reward="boxReward"
            @close="showRequestPrice = false"
            @requestReward="sendRequestReward"
            :creator-name="user.name"
        />
        <app-transition>
            <Dialog
                @no="closeBlockDialog"
                @yes="handleUserBlock"
                v-if="isBlockDialog"
                >{{ $t("dialogs.are_you_sure") }}
            </Dialog>
        </app-transition>
        <mystery-box-dialog 
            v-if="isShowMysteryBox"
            :model-id="user.id"
            :data="user.mysteryBox"
            @close="isShowMysteryBox = false"
            @reward-box="rewardBox"
        />
    </div>
</template>

<script>
import BottomBar from "@/components/app/navigation/BottomBar";
import { mapState, mapActions, mapMutations } from "vuex";
import GradientButton from "@/components/app/button/GradientButton";
import FollowButton from "@/components/app/button/FollowButton";
import ProfileImage from "@/components/app/profile/ProfileImage";
import SwipeTipMenu from "@/components/app/profile/SwipeTipMenu";
import { INSUFFICIENT_FUNDS_ERROR, CURRENCY_SYMBOL } from "@/configs/constants";
import SubscribeDialog from "@/components/app/dialogs/SubscribeDialog";
import ResubscribeDialog from "@/components/app/dialogs/SubscribeDialog";
import UnsubscribeDialog from "@/components/app/dialogs/UnsubscribeDialog";
import InsufficientFundsDialog from "@/components/app/dialogs/InsufficientFundsDialog";
import DirectMessageDialog from "@/components/app/dialogs/DirectMessageDialog";
import ReportMessageDialog from "@/components/app/dialogs/ReportMessageDialog";
import InformDialog from "@/components/app/dialogs/InformDialog";
import SendMessage from "@/components/app/message/SendMessage";
import Dialog from "@/components/app/setting/YesNoDialog";
import IconMenu from "@/assets/images/icons/menu.svg?inline";
import * as clipboardy from "clipboardy";
import { DOMAIN_NAME, SERVER_PROTOCOL } from "@/configs/constants";
import NoStreamsScheduledDialog from "@/components/app/dialogs/NoStreamsScheduledDialog.vue";
import {
    convertUTCDatetimeToLocal,
    formatDate,
    parseDate,
} from "../../../../helpers/functions";
import VerifiedIcon from "@/components/app/common/VerifiedIcon";
import TipMenuDialog from "@/components/app/dialogs/TipMenuDialog";
import DreamGoalDialog from "@/components/app/dialogs/CreatorDreamGoalDialog";
import GiftSubscriptionDialog from "@/components/app/dialogs/GiftSubscriptionDialog";
import MysteryBoxDialog from "@/components/app/dialogs/MysteryBoxDialog";

import DollorIcon from "@/assets/images/icons/new_coin.svg?inline";
import MenuIcon from "@/assets/images/icons/main_menu.svg?inline";
import DreamGoalIcon from "@/assets/images/icons/piggy-bank.svg?inline";
import LiveStreamIcon from "@/components/app/common/LiveStreamIcon.vue";
import HolidayMoodIcon from "@/components/app/icons/HolidayMoodIcon";
import RankFirst from "@/assets/images/icons/rank-first.svg?inline";
import RankSecond from "@/assets/images/icons/rank-second.svg?inline";
import RankThird from "@/assets/images/icons/rank-third.svg?inline";
import hallFames from "@/assets/images/icons/hall-fames.svg?inline";
import TipperIcon from "@/assets/images/icons/tipper-icon.svg?inline";
import MysteryBox from "@/assets/images/icons/magic-box.svg?inline";
import MysteryBoxRewardDialog from "@/components/app/dialogs/MysteryBoxRewardDialog";
import MysteryBoxBadgeIcon from "@/assets/images/icons/gifted-subscription.svg?inline"

export default {
    name: "otherUser",
    data: () => ({
        unsubscribeWarning: false,
        subscribeInfo: false,
        resubscribeInfo: false,
        insufficientFundsError: false,
        isShowTips: false,
        currency: CURRENCY_SYMBOL,
        showDirectMessageDialog: false,
        showReportMessageDialog: false,
        isBlockDialog: false,
        showInsufficientFundsDialog: false,
        showNoStreamsScheduledDialog: false,
        isShowDreamGoalTips:false,
        isShowGiftSubscription:false,
        defaultBundles: [
            {
                isEnabled: true,
                period: 3,
                discount: 15,
            },
            {
                isEnabled: true,
                period: 6,
                discount: 25,
            },
            {
                isEnabled: true,
                period: 12,
                discount: 50,
            },
        ],
        displayUserStory: false,
        InformDialogText: null,
        showInformDialog: false,
        achievements: [],
        tippers: [],
        confirmGiftedSubscrib: false,
        isShowMysteryBox: false,
        showRequestPrice: false,
        mysteryBoxWon: false,
        mysteryBoxResult: '',
        boxReward: '',
        rewardData: {},
        mysteryBoxData: {},
        isBoxActive: false,
        isActionsReady: false,
    }),
    props: {
        width: {
            type: Number,
            default: 0,
        },
        height: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapState({
            profileImage: (state) => state.otherUser.user.profileImage,
            user: (state) => state.otherUser.user,
            currentUser: (state) => state.user.user.data,
            detectOnline: (state) => state.detectOnline
        }),
        isOwnPage() {
            return this.user.id === this.$auth.user().id;
        },
        showSubscribe() {
            return this.user.verified && !this.isOwnPage;
        },
        id() {
            if (typeof this.$route.params.slug !== "undefined") {
                return this.user.id;
            }
            return this.$route.params.id;
        },
        subscribePrice() {
            return this.user.subscribePrice;
        },
        directPrice() {
            return this.user.directMessagePrice;
        },
        userlink() {
            return "/" + this.user.slug;
        },
        userlinkFull() {
            return `${SERVER_PROTOCOL}://${DOMAIN_NAME}${this.userlink}`;
        },
        getSecondMenu() {
            return { name: "user.tips.view", params: { id: this.user.id } };
        },
        isResubscribeAvailable() {
            return (
                this.user &&
                this.user.subscriptionInfo &&
                this.user.subscriptionInfo.cancelled &&
                !this.user.subscriptionInfo.is_gifted_subsciption &&
                new Date() <
                    parseDate(
                        this.user.subscriptionInfo.expired_at
                            .replace("T", " ")
                            .replace(".000000Z", "")
                    )
            );
        },
        getWidth() {
            return this.width > 0 ? this.width : 30;
        },
        getHeight() {
            return this.height > 0 ? this.height : 30;
        },
        isUserLive() {
            return this.user?.stream?.is_live
        },
        progressDreamGoal() {
            const goal = this.user.dream_goal.data.price;
            const received = this.user.dream_goal.data.collected_tips;

            if (!goal || goal === 0) return 0;
            const percentage = (received / goal) * 100;

            return Math.min(100, Math.max(0, percentage));
        },
        isCreatorSubscribe() {
            return this.user?.subscriptionInfo?.is_gifted_subsciption ?? false
        },
        isUserOnline() {
            const userOnline = this.detectOnline.onlineUsers?.some(u => {
                return u.id === this.user.id;
            })
            return userOnline;
        },
        mysteryBoxAvailable() {
            return this.user.mysteryBox.total_boxes != this.user.mysteryBox.sold_boxes && !this.mysteryBoxData.is_prize_confirmed;
        },
    },
    methods: {
        formatDate,
        convertUTCDatetimeToLocal,
        ...mapActions([
            "setOtherUser",
            "setOtherUserBySlug",
            "sendUserTip",
            "subscribe",
            "resubscribe",
            "unsubscribe",
            "sendBlockedUser",
            "sendUnblockedUser",
            "sendReportUser",
            "sendTipMessage",
            "buyDirectMessage",
            "sendDreamGoalTip",
            'fetchAchievements',
            'fetchTopTippersByUser',
            'sendGiftSubscription',
            'checkBoxOpened',
            'requestPrice',
        ]),
        ...mapMutations(["showSnackBar"]),

        async sendTip(model) {
            await this.sendTipMessage({
                user_id: this.user.id,
                message: model.text,
                ...model,
            })
                .then(() => {
                    this.$router.push({
                        name: "user.own.chat",
                        params: { id: this.user.id },
                    });
                })
                .catch((e) => {
                    if (e.response.data.err_key === INSUFFICIENT_FUNDS_ERROR) {
                        this.insufficientFundsError = true;
                    }
                });
        },
        async sendRequestReward(model) {
            await this.requestPrice({
                user_id: this.user.id,
                ...model,
            }) .then(() => {
                    this.$router.push({
                        name: "user.own.chat",
                        params: { id: this.user.id },
                    });
                })
                .catch((e) => {                   
                });
        },
        async sendCreatorGiftSubscription(model) {   
            await this.sendGiftSubscription({
                user_id: this.user.id,
                ...model,
            })
                .then(() => {
                    this.$store.commit("showSnackBar", this.$t("messages.success"));
                    this.$router.push({
                        name: "otherUser.profile.view",
                        params: { id: this.user.id },
                    });
                })
                .catch((e) => {
                    console.log(e);
                });         
        },
        openBlockDialog() {
            this.isBlockDialog = true;
        },
        closeBlockDialog() {
            this.isBlockDialog = false;
        },
        handleUserBlock() {
            if (this.user.blocked) {
                this.sendUnblockedUser({ id: this.user.id }).then(() => {
                    this.$store.commit(
                        "showSnackBar",
                        this.$t("messages.success")
                    );
                });
            } else {
                this.sendBlockedUser({ id: this.user.id }).then(() => {
                    this.$store.commit(
                        "showSnackBar",
                        this.$t("messages.success")
                    );
                });
            }
            this.closeBlockDialog();
            this.setOtherUser(this.id);
        },
        handleSendReportMessage(message) {
            this.sendReportUser({
                defendant_id: this.id,
                accusation: message,
            }).then(() => {
                this.$store.commit("showSnackBar", this.$t("messages.success"));
            });
            this.closeReportMessageDialog();
        },
        openReportMessageDialog() {
            this.showReportMessageDialog = true;
        },
        closeReportMessageDialog() {
            this.showReportMessageDialog = false;
        },
        handleProfileLink() {
            clipboardy.write(this.userlinkFull);
            this.$store.commit(
                "showSnackBar",
                this.$t("dialogs.copied_clipboard")
            );
        },
        async subscribeMethod() {
            this.subscribeInfo = true;
        },
        resubscribeMethod() {
            this.resubscribeInfo = true;
        },
        subscribeFreeMethod() {
            this.handleSubscribe();
        },
        async handleSubscribe(bundleIndex) {
            this.subscribeInfo = false;
            this.showDirectMessageDialog = false;
            await this.subscribe({
                id: this.id,
                bundle:
                    !bundleIndex && bundleIndex !== 0
                        ? null
                        : this.user.subscription.bundles
                        ? this.user.subscription.bundles[bundleIndex]
                        : this.defaultBundles[bundleIndex],
            })
                .then(() => {
                    this.showSnackBar(this.$t("dialogs.subscribed"));
                })
                .catch((error) => {
                    if (error.response.data.err_msg) {
                        this.showInsufficientFundsDialog = true;
                        return;
                    }

                    this.showSnackBar(error.response.data.err_msg);
                });
            await this.setOtherUser(this.id);
        },
        async handleResubscribe() {
            this.resubscribeInfo = false;
            this.showDirectMessageDialog = false;
            await this.resubscribe(this.id)
                .then((res) => {
                    this.showSnackBar(this.$t("dialogs.subscribed"));
                })
                .catch(() =>
                    this.showSnackBar(this.$t("messages.something_went_wrong"))
                );
            await this.setOtherUser(this.id);
        },
        async unsubscribeMethod() {
            this.unsubscribeWarning = true;
            await this.setOtherUser(this.id);
        },
        async handleUnsubscribe(event) {
            this.unsubscribeWarning = false;
            await this.unsubscribe({ id: this.id, reason: event.reason }).then(
                (res) => {
                    if (typeof res.redirectUrl !== "undefined") {
                        this.$window.location = res.redirectUrl;
                    }
                }
            );
            await this.setOtherUser(this.id);
        },
        async clickFollow(action) {
            await this.setOtherUser(this.id);

            if (action === 'followed') {
                this.showSnackBar(`You started following ${this.user.name}`);
            } else if (action === 'unfollowed') {
                this.showSnackBar(`You unfollowed ${this.user.name}`);
            }
        },
        closeUnsubscribeWarning() {
            this.unsubscribeWarning = false;
        },
        closeSubscribeInfo() {
            this.subscribeInfo = false;
            this.resubscribeInfo = false;
        },
        handleCloseInsufficientFundsError() {
            this.insufficientFundsError = false;
        },
        handleCloseDirectMessageDialog() {
            this.showDirectMessageDialog = false;
        },
        async handleDirectMessage() {
            await this.buyDirectMessage(this.id)
                .then((res) => {
                    if (typeof res.redirectUrl !== "undefined") {
                        this.$window.location = res.redirectUrl;
                    }
                    if (typeof res.success !== "undefined") {
                        this.$store.commit("showSnackBar", res.success);
                        this.setOtherUser(this.id);
                        const chat =
                            !this.user.directMessageTurnOff &&
                            this.user.canSendMessages
                                ? {
                                      name: "user.own.chat",
                                      params: { id: this.user.id },
                                  }
                                : null;
                        if (chat) {
                            this.$router.push(chat);
                        }
                    }
                })
                .catch((e) => {
                    if (e.response.data.err_key === INSUFFICIENT_FUNDS_ERROR) {
                        this.insufficientFundsError = true;
                    }
                });
            await this.setOtherUser(this.id);
            this.handleCloseDirectMessageDialog();
        },

        handleShowTips() {
            this.isShowTips = true;
        },
        async handleStreamsButtonClick() {
            const ageVerify = this.$core.storyCore.ageVerification(this.currentUser);
            if (!ageVerify) return [];
            const promise =
                typeof this.$route.params.slug !== "undefined"
                    ? this.setOtherUserBySlug(this.$route.params.slug)
                    : this.setOtherUser(this.$route.params.id);

            await promise.catch(() => {
                this.$router.push({ name: "404" });
            });

            if (!!this.user.stream) {
                this.$router.push({
                    name: "otherUser.profile.viewStreams",
                    params: { slug: this.user.slug },
                });
                return;
            }

            this.showNoStreamsScheduledDialog = true;
        },
        handleBackNav() {
            if (this.$route.params.from && this.$route.params.from == 'content') {
                this.displayUserStory = true
            }
            else {
                this.$router.push({
                    name: this.$route.params.from
                        ? this.$route.params.from
                        : 'search',
                })
            }
        },
        handleShowInformDialog(text) {
            this.InformDialogText = text;
            this.showInformDialog = true;
        },
        handleShowDreamGoalTips() {
            this.isShowDreamGoalTips = true;
        },        
        async sendCreatorDreamGoalTip(model) {
            await this.sendDreamGoalTip({
                user_id: this.user.id,
                ...model,
            })
                .then((res) => {
                    this.user.dream_goal = res;
                    // this.showSnackBar(res.msg)
                })
                .catch((e) => {
                    if (e.response.data.err_key === INSUFFICIENT_FUNDS_ERROR) {
                        this.insufficientFundsError = true;
                    }
                });
        },
        handleShowGiftSubscription() {
            this.isShowGiftSubscription = true;
        },        
        handleMysteryBoxDialog() {
            if(this.mysteryBoxData?.data && this.rewardData?.won && !this.mysteryBoxData.data.prize_requested_at || this.mysteryBoxData?.data && !this.mysteryBoxData?.data?.prize_given_at){
                this.showRequestPrice = true;
            } else {
                this.isShowMysteryBox = true;
            }
        },
        async mysteryBoxOpend() {
            const response = await this.checkBoxOpened({id: this.user.mysteryBox.id,  userId: this.currentUser.id});
            if(response.success) { 
                this.mysteryBoxData = response;
                this.rewardData = {
                    won: response.data.reward_title ? true : false,
                    result: response.data.reward_title,
                    reward: response.data.reward_title,
                    box_id: this.user.mysteryBox.id,
                    is_requested: response.data.prize_requested_at
                };
                // this.mysteryBoxWon = true;
                // this.mysteryBoxResult = `You won: ${response.reward_title}!`;
                // this.boxReward = response.reward_title;
            }
            this.isBoxActive =  this.user.mysteryBox.status || !response?.data?.prize_requested_at;
        },
        rewardBox(reward) {
            this.isShowMysteryBox = false;
            this.rewardData = {
                won: reward.won,
                result: reward.result,
                reward: reward.reward_title,
                box_id: reward.box_id,
                is_requested: reward.prize_requested_at
            };
            this.showRequestPrice = true;
            this.mysteryBoxOpend();
        },
        isMysteryBoxActive() {
            if(this.user.mysteryBox) {
                this.mysteryBoxOpend() 
            }
        }
    },
    async mounted() {
        const promise =
            typeof this.$route.params.slug !== "undefined"
                ? this.setOtherUserBySlug(this.$route.params.slug)
                : this.setOtherUser(this.$route.params.id);

        await promise.catch(() => {
            this.$router.push({ name: "404" });
        });
        this.isMysteryBoxActive();
        this.isActionsReady = true;

        if (this.user.show_achievements_section) {            
            await this.fetchAchievements(this.user.id).then((res) => {
                this.achievements = res;
            });
        }

        if (this.user.show_top_tippers_section) {            
            await this.fetchTopTippersByUser(this.user.id).then((res) => {
                this.tippers = res.tippers;
            });
        }
        this.$mixpanel.identifyUser(this.currentUser.email);
        this.$mixpanel.track('page_view', {
            page: "Other user profile",
            visited_profile: this.user.email,
        });
    },
    components: {
        NoStreamsScheduledDialog,
        UnsubscribeDialog,
        SubscribeDialog,
        ResubscribeDialog,
        InsufficientFundsDialog,
        ProfileImage,
        GradientButton,
        FollowButton,
        BottomBar,
        SwipeTipMenu,
        DirectMessageDialog,
        ReportMessageDialog,
        InformDialog,
        SendMessage,
        Dialog,
        IconMenu,
        VerifiedIcon,
        TipMenuDialog,
        DollorIcon,
        MenuIcon,
        LiveStreamIcon,
        HolidayMoodIcon,
        DreamGoalIcon,
        DreamGoalDialog,
        RankFirst, RankSecond, RankThird,
        hallFames, TipperIcon, GiftSubscriptionDialog, MysteryBoxDialog, MysteryBox,
        MysteryBoxRewardDialog, MysteryBoxBadgeIcon
    },
};
</script>

<style scoped lang="scss">
@import "@/sass/modules/_variables";

.v-menu__content {
    border-radius: 0px;
}

.UserControls {
    &-item {
        .v-list-item__title {
            color: black;
            cursor: pointer;
        }
    }

    &-list {
        background-color: #ffffff !important;
        border-radius: 20px 0px 20px 20px !important;
    }
}

.socials {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.top-icon {
    font-size: 28px;
}

.ProfileImage-wrapper {
    width: 148px;
    position: relative;

    &.without-circle .follow-button {
        right: 10px;
        bottom: 10px;
    }
}

.profile-image {
    height: 136px;
    width: 136px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: whitesmoke;
    border: 6px solid black;
    object-fit: cover;
}

.image-container {
    height: 148px;
    width: 148px;
    border-radius: 50%;
    padding-left: 6px;
    padding-top: 6px;
}

.story-exist {
    background: $grey-background;
}

.has-not-watched-stories {
    background: $accent-background;
}

.name {
    font-size: 1.5em;
}

.counters {
    font-size: 1.5em;
}

.hint {
    display: block;
    font-size: 0.8em;
    color: rgba(255, 255, 255, 0.6);
}

.linked {
    text-decoration: none;
}

.bio {
    color: rgba(255, 255, 255, 0.7);
    // text-align: justify;
    line-height: 1.2em;
    word-break: break-all;
}
.icons-wrapper {
    display: flex;
    justify-content: center;
    padding: 10px;
    border-radius: 10px;

    .col div {
        gap: 6px;
    }
}

.top-icon {
    text-align: center;
}

.top-icon > div, .top-icon > a {
    display: flex;
    align-items: center;
    justify-content: center;
}

.done {
    border: 1px solid white;
    border-radius: 50%;
    padding: 4px;
}

ul.style-dashed {
    list-style: none;
}

ul.style-dashed li:before {
    content: "—";
    position: relative;
    left: -5px;
}

.is-user-live {
    animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.icon-goal {
    z-index: 999;
}

.other-user {
    &__actions {
        display: flex;
        justify-content: center;
        padding: 10px;
        border-radius: 10px;

        &-item {
            width: 20%;
            padding: 0 3px;
        }

        &-icon-box {
            width: 100%;
            height: 65px;
            background-color: #111111; 
            position: relative;
            padding: 10px 5px 5px;
            border-radius: 5px;
        }

        &-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 16px;

            span {
                font-size: 11px; 
                line-height: 11px;
                position: absolute;
                bottom: 5px;
                left: 50%;
                transform: translateX(-50%);
            }
        }
  }
}


.other-profile-wrapper { padding: 24px 24px 100px; }

h3.section-title { display: flex; align-items: center; justify-items: flex-start; gap: 16px; font-weight: 700; font-size: 24px; line-height: 160%; }

.achievements-scroll { display: flex; gap: 7px; margin: 0px -8px; }
.achievements-scroll .achievement-card { background-color: #171717;min-width: 145px; border-radius: 10px; }
.achievements-title { font-weight: 500 !important; font-size: 14px; line-height: 160%; color: #FFFFFF; }
.achievements-date { font-weight: 500; font-size: 12px; line-height: 160%; color: rgba(255, 255, 255, 0.5); }
.achievements-scroll .achievement-card svg { margin: 10px 0; }

.tipper-items { display: flex; align-items: flex-end; gap: 7px; }
.tipper-items .tipper-item { width: 33.33%; }
.tipper-items .tipper-item .tipper-card { background: rgba(23, 23, 23, 1); border: 1px solid rgba(255, 255, 255, 0.05); border-radius: 8px; padding: 8px 15px; }
.tipper-items .tipper-item.first-place { height: 190px; order: 1; }
.tipper-items .tipper-item.second-place { height: 162px;  order: 0; }
.tipper-items .tipper-item.third-place { height: 135px; order: 2; }
.tipper-items .tipper-item.first-place .tipper-card { height: 190px; order: 1; background: rgba(255, 120, 5, 1); }
.tipper-items .tipper-item.first-place .tipper-card .ranking-number { color: #000000; font-weight: 700; font-size: 36px; line-height: 160%; }
.tipper-items .tipper-item.second-place .tipper-card { height: 162px;  order: 0; }
.tipper-items .tipper-item.third-place .tipper-card { height: 135px; order: 2; }

.tipper-items .tipper-item.second-place .tipper-card .ranking-number, .tipper-items .tipper-item.third-place .tipper-card .ranking-number { color: rgba(255, 120, 5, 1); font-weight: 700; font-size: 22px; line-height: 160%; }

.tipper-items .tipper-item .avatar { height: 46px !important; width: 46px !important; border-radius: 100%; border: 2px solid rgba(255, 120, 5, 1); }
.tipper-items .tipper-item.first-place .avatar { height: 70px !important; width: 70px !important; border: 2px solid #fff; }
.tipper-items .tipper-item.first-place .tipper-card .tipper-username { color: rgba(23, 23, 23, 1) !important; font-size: 16px; font-weight: 500; }
.tipper-items .tipper-item.first-place .tipper-card .tipper-value { font-size: 16px; font-weight: 500 !important; color: rgba(23, 23, 23, 1) !important;  }
.tipper-items .tipper-item .tipper-card .tipper-username { font-weight: 500; font-size: 14px; line-height: 160%; color: rgba(255, 255, 255, 1); }
.tipper-items .tipper-item .tipper-card .tipper-value { color: rgba(255, 255, 255, 0.5); font-weight: 500 !important; font-size: 12px; line-height: 160%; }
.country { color: rgba(255, 255, 255, 0.7); text-align: center; line-height: 1.2em;}
.flags { width: 17px; height: 13px; object-fit: cover; border-radius: 2px;}

.online-badge {
    display: flex;
    align-items: center;
    gap: 4px;
}

.online-text {
    color: #18c75a;
    font-weight: 600;
    letter-spacing: 1px;
    font-size: 14px;
}

.online-dot {
    width: 12px;
    height: 12px;
    background-color: #18c75a;
    border-radius: 50%;
    position: relative;
}

.online-dot::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background-color: #18c75a;
    animation: pulse 1.4s infinite;
    opacity: 0.4;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.9);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

.mystery-label .mystery {
    top: 38px;
}

.mystery-label .box {
    top: 52px;
}
</style>
